import { memo, useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { BadgeType } from "../../redux/Task/TaskApi";
import {
  MenuOptions,
  Option,
} from "../../shared/components/CommonFilters/CommonFilterMenu";
import Header from "../../shared/components/CommonPageHeader/Header";
import Layout from "../../shared/components/LayoutV2";
import { usePermissions } from "../../utils/permission";
import AllTaskList from "./AllTaskList";
import CreatedTasks from "./CreatedTasks";
import MyTaskList from "./MyTaskList";
import TaskSubheader from "./TaskSubHeader";

const MENU_OPTION: Array<MenuOptions> = [
  {
    id: "status",
    title: "Task Status",
    options: [
      {
        id: "completed",
        title: "Complete",
      },
      {
        id: "pending",
        title: "Pending",
      },
    ],
  },
  {
    id: "priority",
    title: "Priority",
    options: [
      {
        id: BadgeType.LOW,
        title: "Low",
      },
      {
        id: BadgeType.MEDIUM,
        title: "Medium",
      },
      {
        id: BadgeType.URGENT,
        title: "Urgent",
      },
    ],
  },
];

const validTabs = [0, 1, 2];
const TasksContainer = () => {
  const { Task_ListAllTask } = usePermissions();
  const [searchParams, setSearchParams] = useSearchParams();

  const urlActiveTab = parseInt(searchParams.get("activeView") || "");
  const [tabValue, setTabValue] = useState<number>(
    validTabs.includes(urlActiveTab) ? urlActiveTab : 0,
  );

  useEffect(() => {
    setTabValue(validTabs.includes(urlActiveTab) ? urlActiveTab : 0);
  }, [urlActiveTab]);

  const handleTabChange = useCallback(
    (event: React.SyntheticEvent, newTabValue: number) => {
      setSearchParams(
        (params: any) => {
          params.set("activeView", newTabValue);
          return params;
        },
        { replace: true },
      );
      setTabValue(newTabValue);
    },
    [setSearchParams],
  );

  const [filters, setFilters] = useState<Option>({});
  const [searchText, setSearchText] = useState<string>("");

  const setFilterObject = useCallback((option: Option) => {
    setFilters((prev) => ({
      ...prev,
      ...option,
    }));
  }, []);

  return (
    <Layout
      header={
        <Header
          options={MENU_OPTION}
          filters={filters}
          setFilters={setFilterObject}
          onSearch={setSearchText}
          defaultSelectedId="task"
        />
      }
      subHeader={
        <TaskSubheader handleTabChange={handleTabChange} tabValue={tabValue} />
      }
      body={
        <>
          <CreatedTasks
            tabValue={tabValue}
            filters={filters}
            searchText={searchText}
          />
          <MyTaskList
            tabValue={tabValue}
            filters={filters}
            searchText={searchText}
          />
          {Task_ListAllTask && (
            <AllTaskList
              tabValue={tabValue}
              filters={filters}
              searchText={searchText}
            />
          )}
        </>
      }
    />
  );
};

export default memo(TasksContainer);
